"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_hooks_1 = require("@apollo/react-hooks");
const graphql_1 = require("../../graphql");
exports.useUpdateContentFeedMutation = (_a) => {
    var props = tslib_1.__rest(_a, []);
    const [update, updateResult] = react_hooks_1.useMutation(graphql_1.updateContentFeed, Object.assign({}, props));
    return { update, updateResult };
};
//# sourceMappingURL=useUpdateContentFeedMutation.js.map